import { useReducer } from "react";
import { OFFSET } from "./constants";

export const ActionType = {
  DISPLAY_MORE_PRODUCTS: "@products/DISPLAY_MORE_PRODUCTS",
  FETCH_FROM_DB: "@products/FETCH_FROM_DB",
  FETCH_ALL: "@products/FETCH_ALL",
};

const defaultState = {
  products: [],
  isFetching: true,
  page: 0,
  error: {},
};

const productReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.DISPLAY_MORE_PRODUCTS:
      const nextPage = state.page + 1;
      return {
        ...state,
        page: nextPage,
        offset: nextPage * OFFSET,
      };
    case ActionType.FETCH_FROM_DB:
      return {
        ...state,
        page: 1,
        offset: OFFSET,
        isFetching: false,
        products: action.products,
      };
    // case ActionType.SET_PRODUCTS:
    //   return {
    //     ...state,
    //     page: 1,
    //     offset: OFFSET,
    //     isFetching: false,
    //     products: [
    //       ...state.products,
    //       ...action.products
    //     ]
    //   };
    case ActionType.FETCH_ALL:
      const numOfProducts = state.products ? state.products.length : 0;
      const page = Math.round(numOfProducts / OFFSET);
      return {
        ...state,
        page: page,
        offset: page * OFFSET,
        isFetching: false,
      };

    default:
      return state;
  }
};

export const useProductReducer = (initialState) =>
  useReducer(productReducer, initialState || defaultState);
